<template>
  <div class="maintain-item-watch-bd">
    <div class="layout-head ub">
      <div class="img-box">
        <img
          v-if="deviceImage"
          :src="getAttachUrl(deviceImage)"
          alt=""
        >
      </div>
      <div class="device-info">
        <h1>{{detail.productCode}}</h1>
        <h2>{{detail.productName}}</h2>
        <p>{{detail.productDesc}}</p>
      </div>
    </div>
    <div class="layout-wrap">
      <div class="title">{{$t('asm_maintain_item_watch.byxlb')}}</div>
      <ul class="maintain-info-list">
        <li
          v-for="(item, index) in detail.basicItemList"
          :key="index"
        >
          <maintain-info-item
            :itemId="item.itemId"
            :itemName="item.itemName"
            :num="index"
          ></maintain-info-item>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import maintainInfoItem from './maintain_info_item';

export default {
  name: 'maintain_item_watch',
  components: {
    maintainInfoItem,
  },
  data() {
    return {
      upkeepItemId: '',
      productCode: '',
      deviceImage: {},
      detail: {},
      dialogImageUrl: '',
      dialogVisible: false,
    };
  },
  mounted: function () {
    this.productCode = this.getJump('productCode');
    this.getDeviceInfo();
  },
  methods: {
    getProductImg(productCodeId) {
      if (productCodeId) {
        this.$getJSON(`${apis.OssAttach}/${productCodeId}/dms.product.icon`).then((res) => {
          this.deviceImage = res.data[0] || {};
        });
      }
    },
    onPreviewImage(file) {
      this.dialogImageUrl = this.getAttachUrl(file);
      this.dialogVisible = true;
    },
    getDeviceInfo: function () {
      this.$getJSON(apis.BasicItemListByProduct, { productCode: this.productCode }).then((res) => {
        this.detail = res.data;
        this.getProductImg(this.detail.productCodeId);
      });
    },
  },
};
</script>

<style lang='scss' scoped>
@import 'style/colors.scss';

.maintain-item-watch-bd {
  height: calc(100% - 48px);
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  margin: 24px;

  .layout-head {
    padding: 24px 32px;
    height: 190px;
    background-color: #ffffff;
    .img-box {
      width: 140px;
      height: 140px;
      margin-right: 32px;
      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
    .device-info {
      h1 {
        margin-top: 10px;
        line-height: 34px;
        color: #00afff;
        font-size: 24px;
        margin-bottom: 10px;
      }
      h2 {
        line-height: 22px;
        font-size: 16px;
        color: rgba(0, 0, 0, 0.65);
      }
      p {
        margin-top: 10px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 14px;
        line-height: 24px;
      }
    }
  }
  .layout-wrap {
    background-color: #ffffff;
    margin-top: 24px;
    padding: 24px 32px;
    .title {
      color: rgba(0, 0, 0, 0.85);
      font-weight: bold;
      font-size: 16px;
      line-height: 24px;
      margin-bottom: 24px;
    }
    ul li {
      float: left;
      margin-right: 30px;
      margin-bottom: 20px;
    }
  }
}
</style>
